import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PackersMoversService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Get Packers Movers List
  getPackersMoversList(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}admin/packersMovers/list`, data);
  }

  // Get Packers Movers By Id
  getPackersMoversById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}admin/packersMovers/${id}`);
  }

  // Get User Requirements List
  getUserRequirementsList(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}admin/packersMovers/userdetails/list`,
      data,
    );
  }

  // Get User Requirement By Id
  getUserRequirementById(id: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}admin/packersMovers/userdetails/${id}`,
    );
  }
}
